import { render, staticRenderFns } from "./ai-message.vue?vue&type=template&id=4db9784e&scoped=true"
import script from "./ai-message.vue?vue&type=script&lang=js"
export * from "./ai-message.vue?vue&type=script&lang=js"
import style0 from "./ai-message.vue?vue&type=style&index=0&id=4db9784e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db9784e",
  null
  
)

export default component.exports